// src/pages/Roadmap.js
import React from 'react';
import '../styles/Roadmap.css'; // Optional: for custom styles or reuse your index.css

const Roadmap = () => {
  return (
  <div className="roadmap-page">
    <div className="container fade-in">
      <h1>✨ Chaptr.org 2025–2026 Roadmap</h1>
      <p>Hello to all our future readers, early supporters, and curious minds!</p>
      <p>At Chaptr.org, we’re building something simple yet ambitious: a digital library that makes reading classic and contemporary books easier, more beautiful, and more accessible than ever before.</p>
      <p>We’re still in the early days — no glossy launch announcements (yet!), no overhyped promises. Just a small, dedicated team working behind the scenes to shape the foundations of a platform we believe in.</p>
      <p>As of today (July 12th, 2025), our Library design is ready, our Book Details pages are live, and our brand-new social channels and BuyMeACoffee page are up and running. But our true launch is still ahead of us — and we want to share exactly where we are, what we’re working on, and what comes next.</p>
      <p>If you’re here early, know this: you’re witnessing the beginning of something we hope will grow with you. 🪴✨</p>

      <hr className="divider" />

      <h2>✅ What We’ve Actually Done So Far</h2>
      <p><span className="highlight">1. Designed the Library:</span> We’ve laid out a streaming-style Library experience — clean, modern, and focused on discovery.</p>
      <p><span className="highlight">2. Built the Book Details Page:</span> Each book now has its own polished page for summaries, cover art, and level info.</p>
      <p><span className="highlight">3. Opened Our Social Channels:</span> Our social accounts are live — ready to share updates, sneak peeks, and behind-the-scenes moments.</p>
      <p><span className="highlight">4. Set Up BuyMeACoffee:</span> We’ve launched our first way for early supporters to back Chaptr.org and help us stay independent.</p>

      <hr className="divider" />

      <h2>🔮 What’s Next</h2>
      <p><span className="highlight">→ Finish the Reader Page</span><br />
        We’re focusing on making our Reader the best experience possible — easy on the eyes, distraction-free, and practical for language learners.
      </p>
      <ul>
        <li>An integrated quiz at the end for quick self-checks.</li>
        <li>Clickable words with a pop-up window that shows:
          <ol type="a">
            <li>the definition tailored for the CEFR level,</li>
            <li>a speaker button to hear the word’s International English Pronunciation,</li>
            <li>an example sentence in context.</li>
          </ol>
        </li>
      </ul>

      <p><span className="highlight">→ Build Proper Profile & Progress Pages</span><br />
        Each reader will have a Profile page with clear progress tracking for both books and quizzes. A separate Quiz Analysis page will help readers see where they excel — and what they might revisit.
      </p>

      <p><span className="highlight">→ Closed Beta (End of September 2025)</span><br />
        We’ll open the doors to our first real users, with at least <strong>10 books</strong> ready to read and test. A dedicated “Give Feedback” page will make it easy for early readers to tell us what they love and what could be better.
      </p>

      <p><span className="highlight">→ Expand the Library Before Launch</span><br />
        We plan to add <strong>10 more books</strong> during the last quarter of 2025. We’ll use the feedback from our beta testers to fine-tune every detail.
      </p>

      <p><span className="highlight">→ Full Launch (01.01.2026)</span><br />
        Chaptr.org goes fully live — open to everyone, with a curated collection, quizzes, progress tracking, and more.
      </p>

      <p><span className="highlight">→ Grow the Community</span><br />
        This year and beyond, we’ll focus on nurturing a supportive community of readers, language learners, teachers, and early supporters.
      </p>

      <p><span className="highlight">→ Keep Expanding the Library</span><br />
        After launch, we plan to add <strong>5–10 books each quarter</strong>, ensuring fresh content and steady growth.
      </p>

      <p><span className="highlight">→ Prepare for Educator Tools</span><br />
        Behind the scenes, we’ll build the foundations for Educator Dashboards and <strong>Create a Class</strong> features — designed for teachers and schools who want to use Chaptr in their classrooms.
      </p>

      <p><span className="highlight">→ 01.01.2027 — Educator Dashboards Go Live</span><br />
        By January 1st, 2027, we aim to roll out our full suite of Educator tools — including class creation, student tracking, and powerful insights for better teaching.
      </p>

      <hr className="divider" />

      <h2>📖 Why We’ll Stay Open — But Not Free</h2>
      <p>From day one, our goal has been simple: make the first step easy, the next step worth it.</p>
      <p>The <strong>first chaptrs are on us</strong> — open for everyone to discover the joy of reading, learning, and exploring. If you love what you find here, you’ll have the choice to support Chaptr through a simple subscription when we fully launch.</p>
      <p>Every subscription helps us stay independent, grow our library, and build the tools that make reading better — for learners, teachers, and curious minds everywhere.</p>

      <div className="cta-box">
        <h3>☕ A Small Way to Help Now</h3>
        <p>If you like what you’re reading — or just want to see this dream take shape — your early support means the world to us.</p>
        <p><a href="https://www.buymeacoffee.com/chaptrorg" target="_blank" rel="noreferrer">☕ Buy us a coffee here</a> and help us build a calm, beautiful reading space for everyone.</p>
        <p>Every small act of support keeps us focused on what really matters: great books, thoughtful design, and a community that grows together.</p>
      </div>

      <hr className="divider" />

      <h2>📚 Thank You</h2>
      <p>Here’s to the next chaptr — and to writing it together. Follow along. Share your ideas. And keep reading. 💜</p>

      <div className="social-icons">
      <a href="https://twitter.com/chaptrorg" target="_blank" rel="noreferrer">
      <img src="/assets/x.svg" alt="Twitter/X" />
      </a>
      <a href="https://instagram.com/chaptrorg" target="_blank" rel="noreferrer">
      <img src="/assets/instagram.svg" alt="Instagram" />
      </a>
      <a href="https://facebook.com/chaptrorg" target="_blank" rel="noreferrer">
      <img src="/assets/facebook.svg" alt="Facebook" />
      </a>
      </div>

      {/* Footer */}
      <div className="mt-8 mb-6 text-sm text-gray-500 text-center space-y-1">
        <p className="mt-2">
          © 2025 Chaptr.org. All rights reserved.
          <br />
          Terms & Conditions | Privacy Policy | Cookies |{" "}
          <a
            href="mailto:info@chaptr.org"
            className="underline hover:text-gray-400"
          >
            Contact
          </a>
        </p>
      </div>
      
    </div>
  </div>



  );
};

export default Roadmap;
